/**
 * Cart shipping thresholds are configured in USD (theme settings).
 * Converts to the customer's cart currency via Shopify Markets / Shopify.currency.rate.
 */
(function () {
  const BASE_CURRENCY = 'USD';

  const LOCALE_BY_CURRENCY = {
    EUR: 'de-DE',
    GBP: 'en-GB',
    CHF: 'de-CH',
    SEK: 'sv-SE',
    NOK: 'nb-NO',
    DKK: 'da-DK',
    PLN: 'pl-PL',
  };

  function formatMoney(cents, currency) {
    const amount = cents / 100;
    const locale = LOCALE_BY_CURRENCY[currency] || undefined;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  /**
   * Returns presentment-currency cents per 1 USD cent (i.e. multiply USD cents by this rate).
   */
  function getUsdToPresentmentRate(cartCurrency, shopCurrency, dataUsdRate) {
    if (cartCurrency === BASE_CURRENCY) {
      return 1;
    }

    const shopifyCurrency = window.Shopify && Shopify.currency;
    if (
      shopifyCurrency &&
      shopifyCurrency.active === cartCurrency &&
      shopCurrency === BASE_CURRENCY
    ) {
      const rate = parseFloat(shopifyCurrency.rate);
      if (!Number.isNaN(rate) && rate > 0) {
        return rate;
      }
    }

    if (dataUsdRate) {
      const parsed = parseFloat(dataUsdRate);
      if (!Number.isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return null;
  }

  function updateCartShipping(cartTotalCentsOverride) {
    const shipping = document.querySelector('[data-cart-shipping]');
    if (!shipping) return;

    const usdThreshold = parseInt(shipping.dataset.usdThresholdCents, 10) || 0;
    const usdFlat = parseInt(shipping.dataset.usdFlatCents, 10) || 0;
    const shopCurrency = shipping.dataset.shopCurrency;
    const cartCurrency = shipping.dataset.cartCurrency;
    const cartTotal =
      cartTotalCentsOverride != null
        ? cartTotalCentsOverride
        : parseInt(shipping.dataset.cartTotalCents, 10) || 0;

    const rate = getUsdToPresentmentRate(
      cartCurrency,
      shopCurrency,
      shipping.dataset.usdRate
    );

    if (rate == null) {
      shipping.classList.add('cart-shipping--rate-pending');
      return;
    }

    shipping.classList.remove('cart-shipping--rate-pending');

    const threshold = Math.round(usdThreshold * rate);
    const flat = Math.round(usdFlat * rate);
    const amountLeft = threshold - cartTotal;
    const progress = threshold > 0 ? Math.min(100, Math.round((cartTotal * 100) / threshold)) : 0;

    const messageAway = shipping.querySelector('[data-cart-shipping-away]');
    const messageUnlocked = shipping.querySelector('[data-cart-shipping-unlocked]');
    const amountLeftEl = shipping.querySelector('[data-cart-shipping-amount-left]');
    const flatEl = shipping.querySelector('[data-cart-shipping-flat]');
    const progressEl = shipping.querySelector('[data-cart-shipping-progress]');

    if (amountLeft > 0) {
      if (messageAway) messageAway.hidden = false;
      if (messageUnlocked) messageUnlocked.hidden = true;
      if (amountLeftEl) amountLeftEl.textContent = formatMoney(amountLeft, cartCurrency);
      if (flatEl) flatEl.textContent = formatMoney(flat, cartCurrency);
    } else {
      if (messageAway) messageAway.hidden = true;
      if (messageUnlocked) messageUnlocked.hidden = false;
    }

    if (progressEl) {
      progressEl.style.width = progress + '%';
    }

    const estimate = document.querySelector('[data-cart-shipping-estimate]');
    if (estimate) {
      const priceEl = estimate.querySelector('[data-cart-shipping-estimate-price]');
      const freeEl = estimate.querySelector('[data-cart-shipping-estimate-free]');
      if (cartTotal < threshold) {
        if (priceEl) {
          priceEl.hidden = false;
          priceEl.textContent = formatMoney(flat, cartCurrency);
        }
        if (freeEl) freeEl.hidden = true;
      } else {
        if (priceEl) priceEl.hidden = true;
        if (freeEl) freeEl.hidden = false;
      }
    }

    shipping.dataset.cartTotalCents = String(cartTotal);
  }

  function updateCartSubtotal(cartTotalCents, cartCurrency) {
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (!subtotalEl || cartTotalCents == null) return;
    subtotalEl.textContent = `${formatMoney(cartTotalCents, cartCurrency)} ${cartCurrency}`;
  }

  function onCartDrawerRefreshed(cartState) {
    const total = cartState && cartState.total_price;
    const shipping = document.querySelector('[data-cart-shipping]');
    const cartCurrency = shipping && shipping.dataset.cartCurrency;

    if (typeof total === 'number') {
      updateCartShipping(total);
      if (cartCurrency) updateCartSubtotal(total, cartCurrency);
    } else {
      updateWhenReady(5);
    }
  }

  function updateWhenReady(attemptsLeft) {
    const shipping = document.querySelector('[data-cart-shipping]');
    if (!shipping) return;

    const cartCurrency = shipping.dataset.cartCurrency;
    const shopCurrency = shipping.dataset.shopCurrency;
    const rate = getUsdToPresentmentRate(
      cartCurrency,
      shopCurrency,
      shipping.dataset.usdRate
    );

    if (rate == null && attemptsLeft > 0) {
      window.setTimeout(() => updateWhenReady(attemptsLeft - 1), 100);
      return;
    }

    updateCartShipping();
  }

  window.updateCartShippingCurrency = updateCartShipping;
  window.refreshCartShippingCurrency = () => updateWhenReady(25);
  window.onCartDrawerRefreshed = onCartDrawerRefreshed;

  document.addEventListener('DOMContentLoaded', () => updateWhenReady(25));

  // cart:updated is dispatched AFTER CartDrawer.updateFromState has already
  // called onCartDrawerRefreshed, so we only need it for non-drawer cart pages.
  document.addEventListener('cart:updated', (event) => {
    const hasSections = event.detail && event.detail.sections;
    if (hasSections) return; // already handled by onCartDrawerRefreshed inside updateFromState
    const total = event.detail && event.detail.total_price;
    updateCartShipping(typeof total === 'number' ? total : undefined);
  });
})();
